import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledWithdrawalCard = {
  Link: styled.button`
    display: block;
    margin-bottom: 8px;
    padding: 0;
    border: none;
    background: none;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${Color.DARK_GRAY};
    text-align: start;
    text-decoration-line: underline;
    text-underline-offset: 4px;
    cursor: pointer;
  `,
  Description: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${Color.GRAY};
  `,
}
